module.exports = __webpack_public_path__ + "images/psp/RvStorage/RV-winterization-steps.png";